import { connect } from 'react-redux'
import * as OptionActions from '../../actions/option'

import SelectField from '../../components/inputs/SelectField'

const mapStateToProps = (state) => {
  // console.log('RestrictedItemSelect.mapStateToProps');
  const restrictedItems = state.option.restrictedItems

  const options = restrictedItems
    .map((option) => ({
      id: option.id,
      field: option.field,
      label: option.description,
      value: option.name,
      description: option.description
    }))
    .sort((a, b) => a.label > b.label ? 1 : -1)

  return {
    options
  }
}

const mapDispatchToProps = (dispatch) => {
  const loadData = () => {
    return dispatch(OptionActions.retrieveRestrictedItems())
  }

  return {
    loadData
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectField)
